<div class="panel panel-default">
  <div class="panel-heading">
    <div class="row">
      <div class="col-xs-8">
        <h3 class="panel-title">{{ title }}</h3>
      </div>
      <div class="col-xs-4 panel-accessories" *ngIf="linkedComponent">
        <label class="sameAsLabel pull-right">
          <input class="check" type="checkbox" [(ngModel)]="sameAs" />
          <span>Same as {{ linkedComponent.title }}</span>
        </label>
      </div>

      <div class="col-xs-4 panel-accessories" *ngIf="provider">
        <label class="pull-right" style="width: 60%">
          <app-select
            #facilitiesList
            [items]="facilities"
            [allowClear]="true"
            [selected]="selectedFacility"
            [removed]="selectedFacility"
            placeholder="Select a Facility"
          >
          </app-select>
          <app-tooltip [form]="'address'" [uid]="'Facilities'"></app-tooltip>
        </label>
      </div>
    </div>
  </div>
  <div class="panel-body">
    <div class="row">
      <div class="col-md-12">
        <form
          (ngSubmit)="onSubmit()"
          #addressForm="ngForm"
          class="editForm"
          novalidate
          (click)="formClick($event)"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="control-label">Address 1</label>
                <input
                  type="text"
                  class="form-control"
                  maxlength="200"
                  name="Street"
                  [ngModel]="sameAs ? linkedComponent.model.Address1 : model.Address1"
                  (ngModelChange)="
                    sameAs ? linkedComponent.model.Address1 : (model.Address1 = $event)
                  "
                  #Address1="ngModel"
                  [disabled]="sameAs"
                />
                <app-tooltip [form]="'address'" [uid]="'Address1'"></app-tooltip>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label class="control-label">Address 2</label>
                <input
                  type="text"
                  class="form-control"
                  maxlength="100"
                  name="Number"
                  [ngModel]="sameAs ? linkedComponent.model.Address2 : model.Address2"
                  (ngModelChange)="
                    sameAs ? linkedComponent.model.Address2 : (model.Address2 = $event)
                  "
                  #Address2="ngModel"
                  [disabled]="sameAs"
                />
                <app-tooltip [form]="'address'" [uid]="'Address2'"></app-tooltip>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="control-label">City</label>
                <input
                  type="text"
                  class="form-control"
                  maxlength="100"
                  name="CityName"
                  [ngModel]="sameAs ? linkedComponent.model.CityName : model.CityName"
                  (ngModelChange)="
                    sameAs ? linkedComponent.model.CityName : (model.CityName = $event)
                  "
                  #CityName="ngModel"
                  [disabled]="sameAs"
                />
                <app-tooltip [form]="'address'" [uid]="'CityName'"></app-tooltip>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="control-label">State</label>
                <app-select
                  #stateList
                  [items]="states"
                  [allowClear]="true"
                  [selected]="selectedState"
                  [removed]="selectedState"
                  [disabled]="sameAs"
                  placeholder="Select a State"
                >
                </app-select>
                <app-tooltip [form]="'address'" [uid]="'State'"></app-tooltip>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="control-label">Zip Code</label>
                <input
                  type="text"
                  class="form-control"
                  [appInputMask]="util.constants.masks.zipCode"
                  maxlength="15"
                  name="ZipCode"
                  [ngModel]="sameAs ? linkedComponent.model.ZipCode : model.ZipCode"
                  (ngModelChange)="
                    sameAs ? linkedComponent.model.ZipCode : (model.ZipCode = $event)
                  "
                  #ZipCode="ngModel"
                  [disabled]="sameAs"
                />
                <app-tooltip [form]="'address'" [uid]="'ZipCode'"></app-tooltip>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
